import { appendEvent, persist } from './storage';
import { localDate } from './daily';
import type { SaveData, StoredEvent } from '../types';

export const APP_VERSION = '0.1.0';
export const BUILD_NUMBER = '1';

const uuid = (): string => globalThis.crypto?.randomUUID?.() ?? `event-${Date.now()}-${Math.random().toString(16).slice(2)}`;

export class LocalTelemetry {
  private sessionId = uuid();

  constructor(private save: SaveData) {}

  startNewSession(): void {
    this.sessionId = uuid();
  }

  event(name: string, params: Record<string, unknown> = {}): StoredEvent {
    const payload: StoredEvent = {
      name,
      event_id: uuid(),
      event_ts_utc: new Date().toISOString(),
      install_id: this.save.installId,
      app_version: APP_VERSION,
      build_number: BUILD_NUMBER,
      platform: navigator.platform || 'web',
      locale: navigator.language || 'ja-JP',
      timezone_offset: new Date().getTimezoneOffset(),
      acquisition_source: 'internal',
      experiment_variant: 'A',
      session_id: this.sessionId,
      is_internal: true,
      content_date: localDate(),
      ...params,
    };
    appendEvent(this.save, payload);
    persist(this.save);
    return payload;
  }
}
